import { render } from "./ViewAdults.vue?vue&type=template&id=1e32d1d9&scoped=true"
import script from "./ViewAdults.vue?vue&type=script&lang=js"
export * from "./ViewAdults.vue?vue&type=script&lang=js"

import "@/assets/styles/ar/ViewThree.css?vue&type=style&index=0&id=1e32d1d9&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e32d1d9"]])

export default __exports__